import useAuth from "./useAuth";

const useIsMobile = () => {
    const [{ isMobile }] = useAuth();
    return !!isMobile;
}

export default useIsMobile;